import { put, select, take } from '@redux-saga/core/effects'
import { API_STATES } from 'src/ducks/consts'

export default function* ensureFilterTabsLoaded(selectStock, routine) {
  let stock = yield select(selectStock)
  if (stock.tabs.length > 0) return

  // The routine watcher owns the request so cancelling an offers fetch does
  // not cancel the tabs request shared with application bootstrap.
  if (stock.state.tabs !== API_STATES.IN_PROGRESS) {
    yield put(routine())
  }

  stock = yield select(selectStock)
  if (stock.state.tabs === API_STATES.IN_PROGRESS) {
    yield take([routine.SUCCESS, routine.FAILURE])
  }
}
